/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = window.theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 12;
      this.products = '';
      
      if (window.localStorage) {
        try {
          const recentIds = window.localStorage.getItem('recently-viewed');
          if (recentIds && typeof(recentIds) !== "undefined") {
            window.recentlyViewedIds = JSON.parse(recentIds);
          }
        } catch (e) {
          // SecurityError can occur in sandbox/iframe contexts
        }
      }
    }

    connectedCallback() {
      const observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: '100% 0px',
        threshold: 0
      });
      observer.observe(this);
    }

    handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);
      this.buildUrl();
    }

    buildUrl() {
      if (!window.recentlyViewedIds) return;
      let i = 0;
      
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.initSlider();
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    async initSlider() {
      const slider = this.querySelector('.products-slider:not(.keen-loaded)');
      if (!slider) return;
  
      try {
        const { default: KeenSlider, sliderArrows } = await import(window.modules['keen-slider']);  
        const settings = JSON.parse(
          slider.getAttribute('data-slider-settings')
        ) || {};
        settings.detailsChanged = (slider) => {
          if (!slider.options) return;
          if (slider.options.disabled) {
            slider.container.classList.remove('keen-loaded');
          } else {
            slider.container.classList.add('keen-loaded');
          }
        };
        settings.destroyed = (slider) => {
          slider.container.classList.remove('keen-loaded');
        };
    
        KeenSlider(slider, settings, [sliderArrows]);
      } catch (e) {
        if (typeof Bugsnag !== 'undefined') Bugsnag.notify(e);
        console.warn(e);
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}


/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    const product = document.querySelector('recently-viewed-products');

    if (product) {
      handle = product.dataset.productHandle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    try {
      const recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds && typeof (recentIds) !== "undefined") {
        window.recentlyViewedIds = JSON.parse(recentIds);
      }
    } catch (e) {
      // SecurityError can occur in sandbox/iframe contexts
    }
  }

  if (!window.recentlyViewedIds) window.recentlyViewedIds = [];

  // Remove current product if already in recently viewed array
  const i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);
  
  if (window.localStorage) {
    try {
      window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
    } catch (e) {
      // SecurityError can occur in sandbox/iframe contexts
    }
  }
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}